import React from 'react';
import { Content, Row, Col, Title, Text, Button, Image } from 'components';
import { SideMenu } from '../components';
import { Input, Spin } from 'antd';
import plus_w from 'assets/plus_w.svg';
import { Rating } from './components';
import { STORE_URL } from 'utils';

const { TextArea } = Input;

const MypageReviewFormPresenter = (props) => {
  /* ===== Props ===== */
  const {
    order,
    rating,
    onRating,
    inputValue,
    onChange,
    files,
    onFileChange,
    maxFileLength,
    maxImageSize,
    maxVideoSize,
    maxImageSourceSize,
    maxVideoSourceSize,
    isLoading,
    mediaProcessingText,
    onSubmit,
    submitType,
    screenSize,
  } = props;
  /* ===== VARIABLE ===== */

  /* ===== State ===== */
  const fileInputRef = React.useRef(null);

  /* ===== Function ===== */

  /* ===== Render ===== */
  return (
    <React.Fragment>
      <Spin spinning={isLoading}>
        <Content
          maxWidth={1820}
          padding={screenSize >= 768 ? '120px 0px' : '60px 0'}
        >
          <Row gutter={25}>
            <Col x={0} md={1} xl={2}></Col>
            <Col x={0} md={6} xl={4}>
              <SideMenu />
            </Col>
            <Col x={24} md={16} xl={16}>
              <Content
                maxWidth={'100%'}
                padding={
                  screenSize >= 1200
                    ? '0 0 0 95px'
                    : screenSize >= 768
                      ? '0 0 0 20px'
                      : '0'
                }
              >
                <Title
                  style={{
                    fontSize:
                      screenSize >= 768 ? 32 : screenSize >= 500 ? 28 : 20,
                    fontWeight: 700,
                    paddingBottom: 24,
                    borderBottom: '2px solid var(--black-color)',
                  }}
                >
                  리뷰 작성
                </Title>

                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '32px 0',
                    borderBottom: '1px solid #ddd',
                  }}
                >
                  <Image
                    src={order?.product?.thumbnail}
                    alt={order?.product?.product_name}
                    width={90}
                    height={111}
                  />
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      textAlign: 'start',
                      marginLeft: 24,
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: 700,
                        marginBottom: 4,
                        width: 'fit-content',
                        borderBottom: '1px solid var(--black-color)',
                      }}
                    >
                      {order?.shop_information?.shop_information_name}
                    </Text>
                    <Text
                      style={{
                        fontSize: screenSize >= 768 ? 18 : 15,
                        fontWeight: 700,
                        marginBottom: 8,
                        wordBreak: 'keep-all',
                        webkitLineClamp: 'unset',
                      }}
                    >
                      {order?.product?.product_name}
                    </Text>
                    <Text
                      style={{
                        fontSize: 14,
                        fontWeight: 400,
                        color: 'var(--dark-gray-color)',
                      }}
                    >
                      {order?.product?.product_option
                        ? order?.product?.product_option
                            .map((cur) =>
                              cur.option
                                .map((op) => op.option_name)
                                .join(' / '),
                            )
                            .join(' / ')
                        : null}
                    </Text>
                  </div>
                </div>

                <div
                  style={{ padding: '32px 0', borderBottom: '1px solid #ddd' }}
                >
                  <Text
                    style={{
                      fontSize: screenSize >= 768 ? 20 : 16,
                      fontWeight: 700,
                      marginBottom: 12,
                    }}
                  >
                    상품은 만족하셨나요?
                  </Text>
                  <Rating rating={rating} onClick={(rate) => onRating(rate)} />
                </div>
                <div style={{ padding: '32px 0' }}>
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                  >
                    {files.length < maxFileLength ? (
                      <div
                        style={{
                          backgroundColor: 'rgba(0, 0, 0, 0.7)',
                          width: 100,
                          height: 100,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: mediaProcessingText
                            ? 'not-allowed'
                            : 'pointer',
                          opacity: mediaProcessingText ? 0.5 : 1,
                        }}
                        onClick={() => {
                          if (!mediaProcessingText)
                            fileInputRef.current.click();
                        }}
                      >
                        <img src={plus_w} alt="plus icon" />
                        <input
                          ref={fileInputRef}
                          id="upload"
                          type="file"
                          multiple={true}
                          accept={'image/*,video/*'}
                          disabled={Boolean(mediaProcessingText)}
                          onChange={async (e) => {
                            await onFileChange('add', e.target.files);
                            // 같은 파일을 다시 선택할 수 있도록 input 값을 초기화합니다.
                            e.target.value = '';
                          }}
                        />
                      </div>
                    ) : null}

                    {files.map((file, index) => {
                      const link = file?.review_file_id
                        ? `${STORE_URL}/${file?.file_url}`
                        : URL.createObjectURL(file);

                      return (
                        <div style={{ position: 'relative', top: 0, left: 0 }}>
                          {file.type.startsWith('image/') ||
                          file.type.startsWith('IMAGE') ? (
                            <Image src={link} width={100} height={100} />
                          ) : (
                            <video
                              src={link}
                              width={100}
                              height={100}
                              muted
                              loop
                              autoPlay
                            />
                          )}

                          <button
                            style={{
                              position: 'absolute',
                              top: -10,
                              right: -10,
                              width: 20,
                              height: 20,
                              zIndex: 1,
                              cursor: 'pointer',
                              background: '#111111',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                            onClick={() => onFileChange('remove', index)}
                          >
                            <img
                              src={plus_w}
                              alt="plus icon"
                              style={{ transform: 'rotate(45deg)' }}
                            />
                          </button>
                        </div>
                      );
                    })}
                  </div>
                  {mediaProcessingText ? (
                    <Text
                      size={14}
                      style={{
                        marginTop: 12,
                        color: 'var(--primary-color)',
                        webkitLineClamp: 'none',
                      }}
                    >
                      {mediaProcessingText}
                    </Text>
                  ) : null}
                  <Text
                    size={14}
                    style={{
                      marginTop: 12,
                      webkitLineClamp: 'none',
                    }}
                  >
                    최대 {maxFileLength}개 / 원본 파일 기준 이미지는 최대{' '}
                    {maxImageSourceSize / (1024 * 1024)}MB, 동영상은 최대{' '}
                    {maxVideoSourceSize / (1024 * 1024)}MB까지 선택할 수
                    있습니다.
                    <br />
                    등록 시 이미지는 {maxImageSize / (1024 * 1024)}MB,
                    동영상은 {maxVideoSize / (1024 * 1024)}MB 이하로
                    최적화됩니다.
                  </Text>
                  <Text
                    size={14}
                    color={'var(--red-secondary-color)'}
                    style={{
                      marginTop: 24,
                      webkitLineClamp: 'none',
                    }}
                  >
                    상품과 무관한 사진/동영상을 첨부한 리뷰는 통보없이 삭제 및
                    적립 혜택이 회수됩니다.
                  </Text>
                  <Text
                    size={14}
                    color={'var(--red-secondary-color)'}
                    style={{
                      webkitLineClamp: 'none',
                      marginTop: 10,
                    }}
                  >
                    고객님께서 남겨주시는 소중한 리뷰는 보다 원활한 운영을 위해
                    확인 후 등록됩니다.
                    <br />
                    내부 정책에 따라 확인 후 신속히 게시해 드리겠습니다.
                  </Text>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div style={{ position: 'relative' }}>
                    <TextArea
                      onChange={(e) => onChange(e.target.value)}
                      value={inputValue}
                      //rows={4}
                      placeholder="최소 15자 이상 작성해주세요."
                      style={{
                        border: '1px solid #DDDDDD',
                        height: 300,
                        padding: 40,
                      }}
                      maxLength={255}
                    />
                    <Text
                      style={{
                        position: 'absolute',
                        top: 20,
                        right: 20,
                        fontSize: 14,
                        color: 'var(--dark-gray-color)',
                      }}
                    >
                      {inputValue.length}
                    </Text>
                  </div>
                </div>

                <Text
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '32px 0',
                    fontSize: 14,
                    lineHeight: 1.75,
                  }}
                >
                  <span
                    style={{
                      marginBottom: 16,
                      fontWeight: 700,
                    }}
                  >
                    리뷰 작성 유의사항
                  </span>
                  <span>∙ 최초 등록된 리뷰 기준으로 포인트가 지급됩니다.</span>
                  <span>
                    ∙ 적립 예상 포인트는 리뷰 등록 완료 후 즉시 지급됩니다.
                  </span>
                  <span>
                    ∙ 상품과 무관하거나 비속어가 포함된 리뷰, 그 외 리뷰
                    운영정책에 위배되는 리뷰는 고지 없이 블라인드 후 경고
                    조치됩니다.
                  </span>
                  <span>∙ 경고 누적 시 리뷰 작성이 제한될 수 있습니다.</span>
                </Text>
                <div
                  maxWidth={'100%'}
                  padding={0}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: screenSize >= 768 ? 100 : 60,
                  }}
                >
                  <Button
                    style={{
                      width: '22%',
                      minWidth: 165,
                      padding: screenSize >= 768 ? '18px 52px' : '12px 35px',
                      fontWeight: 700,
                      borderRadius: '2px',
                    }}
                    onClick={() => onSubmit(submitType)}
                    disabled={Boolean(mediaProcessingText)}
                  >
                    {submitType === 'CREATE' ? '등록하기' : '수정하기'}
                  </Button>
                </div>
              </Content>
            </Col>
            <Col x={0} md={1} xl={2}></Col>
          </Row>
        </Content>
      </Spin>
    </React.Fragment>
  );
};

export default MypageReviewFormPresenter;
